// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3NsW8","footer":"ModalError_footer__2BYvx"};